<template>
  <div class="gift-switch" @click="onClick" :class="{ 'selected': section === 'gift' }">
    <div class="overlay"></div>
    <button>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.71354 0C3.90951 0 3.31055 0.268555 2.95573 0.690104C2.60091 1.11165 2.5 1.63574 2.5 2.08333C2.5 3.14779 3.07617 4.01204 3.86719 4.57031C4.11133 4.74284 4.37012 4.87956 4.64844 5H0V9.58333H0.833333V20H19.1667V9.58333H20V5H15.3516C15.6299 4.87956 15.8887 4.74284 16.1328 4.57031C16.9238 4.01204 17.5 3.14779 17.5 2.08333C17.5 1.63574 17.3991 1.11165 17.0443 0.690104C16.6895 0.268555 16.0905 0 15.2865 0C14.4548 0 13.7826 0.351562 13.2812 0.833333C12.7799 1.3151 12.4202 1.9222 12.0833 2.5C11.7464 3.0778 11.429 3.63281 11.0938 4.01042C10.7585 4.38802 10.4525 4.58333 10 4.58333C9.54753 4.58333 9.24154 4.38802 8.90625 4.01042C8.57096 3.63281 8.25358 3.0778 7.91667 2.5C7.57975 1.9222 7.22005 1.3151 6.71875 0.833333C6.21745 0.351562 5.54525 0 4.71354 0ZM4.71354 0.833333C5.32389 0.833333 5.74056 1.05469 6.13281 1.43229C6.52506 1.8099 6.87012 2.34863 7.20052 2.91667C7.53092 3.4847 7.85482 4.07552 8.28125 4.55729C8.28939 4.56706 8.29915 4.57357 8.30729 4.58333H6.66667C5.82682 4.58333 4.95931 4.33268 4.33594 3.89323C3.71256 3.45378 3.33333 2.8597 3.33333 2.08333C3.33333 1.76921 3.4082 1.45833 3.59375 1.23698C3.7793 1.01562 4.08366 0.833333 4.71354 0.833333ZM15.2865 0.833333C15.9163 0.833333 16.2207 1.01562 16.4062 1.23698C16.5918 1.45833 16.6667 1.76921 16.6667 2.08333C16.6667 2.8597 16.2874 3.45378 15.6641 3.89323C15.0407 4.33268 14.1732 4.58333 13.3333 4.58333H11.6927C11.7008 4.57357 11.7106 4.56706 11.7188 4.55729C12.1452 4.07552 12.4691 3.4847 12.7995 2.91667C13.1299 2.34863 13.4749 1.8099 13.8672 1.43229C14.2594 1.05469 14.6761 0.833333 15.2865 0.833333ZM0.833333 5.83333H7.5V8.75H0.833333V5.83333ZM8.33333 5.83333H11.6667V9.08854C11.6667 9.10156 11.6667 9.11458 11.6667 9.1276C11.6667 9.14062 11.6667 9.15365 11.6667 9.16667C11.6634 9.19759 11.6634 9.22689 11.6667 9.25781V19.1667H8.33333V9.24479C8.33659 9.21875 8.33659 9.19271 8.33333 9.16667C8.33496 9.14876 8.33496 9.13249 8.33333 9.11458C8.33333 9.10156 8.33333 9.08854 8.33333 9.07552V5.83333ZM12.5 5.83333H19.1667V8.75H12.5V5.83333ZM1.66667 9.58333H7.5V19.1667H1.66667V9.58333ZM12.5 9.58333H18.3333V19.1667H12.5V9.58333Z" fill="#1A92B8"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    section: {},
  },
  methods: {

    onClick() {
      this.$emit('select', this.section == 'gift' ? 'main' : 'gift');
    }
  }
}
</script>

<style lang="scss" scoped>
//
.gift-switch {
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
  height: 50px;
  border-radius: 14px 0 0 0;
  overflow: hidden;
  
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
  }

  .overlay {
    left: -50%;
    top: -50%;
    width: 100%;
    height: 100%;
    transform: scale(0);
    position: absolute;
    background: #AAD9E7;
    border-radius: 100%;
    transition: transform 0.3s ease;
  }

  &.selected {
    .overlay {
      transform: scale(2);
    }
    // button {
    //   svg {
    //     fill: #fff
    //   }
    // }
  }
}

</style>